module.exports = __webpack_public_path__ + "static/media/cebolas_editado_editado.58f6128b.jpg";